<mat-slide-toggle
    color="accent"
    labelPosition="before"
    [checked]="settingsDarkmodeChecked === true"
    (change)="toggleDarkmode()"
    >{{ 'GLOBAL.CHANGECOLORTHEME.DARKMODE' | translate }}</mat-slide-toggle
>
